import React from "react"

import { ProductQuickInfos as ProductQuickInfosType } from "entities/products/types/QuickInfos"

import { ProductQuickInfosContent } from "./ProductQuickInfosContent"
import {
  ProductQuickInfosContext,
  ProductQuickInfosContextValue
} from "./ProductQuickInfosContext"
import { ProductQuickInfosCopyToClipboard } from "./ProductQuickInfosCopyToClipboard"
import { useProductQuickInfosClipboard } from "./model/useProductQuickInfosClipboard"
import "./styles/_product-quick-infos.scss"

interface ProductQuickInfosRootProps {
  quickInfos: ProductQuickInfosType | undefined
  children?: React.ReactNode
}

const ProductQuickInfosRoot = React.memo(
  ({ quickInfos, children }: ProductQuickInfosRootProps) => {
    const { copyToClipboard } = useProductQuickInfosClipboard(quickInfos)

    const contextValue = React.useMemo<ProductQuickInfosContextValue>(
      () => ({ quickInfos, copyToClipboard }),
      [quickInfos, copyToClipboard]
    )

    if (!quickInfos || Object.keys(quickInfos).length === 0) {
      return null
    }

    return (
      <ProductQuickInfosContext.Provider value={contextValue}>
        {children}
      </ProductQuickInfosContext.Provider>
    )
  }
)

export const ProductQuickInfos = Object.assign(ProductQuickInfosRoot, {
  Root: ProductQuickInfosRoot,
  CopyToClipboard: ProductQuickInfosCopyToClipboard,
  Content: ProductQuickInfosContent
})
